import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.1173 12.0751L15.2839 10.6917C15.1089 10.3834 14.9506 9.80008 14.9506 9.45842V7.35008C14.9506 5.39175 13.8006 3.70008 12.1423 2.90841C11.7089 2.14175 10.9089 1.66675 9.99227 1.66675C9.08394 1.66675 8.26727 2.15841 7.83394 2.93341C6.20894 3.74175 5.08394 5.41675 5.08394 7.35008V9.45842C5.08394 9.80008 4.9256 10.3834 4.7506 10.6834L3.90894 12.0751C3.5756 12.6334 3.5006 13.2501 3.70894 13.8167C3.90894 14.3751 4.38394 14.8084 5.0006 15.0167C6.61727 15.5667 8.31727 15.8334 10.0173 15.8334C11.7173 15.8334 13.4173 15.5667 15.0339 15.0251C15.6173 14.8334 16.0673 14.3917 16.2839 13.8167C16.5006 13.2417 16.4423 12.6084 16.1173 12.0751Z",
		fill: "#407BFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.3587 16.6751C12.0087 17.6417 11.0837 18.3334 10.0004 18.3334C9.34206 18.3334 8.69206 18.0667 8.23372 17.5917C7.96706 17.3417 7.76706 17.0084 7.65039 16.6667C7.75872 16.6834 7.86706 16.6917 7.98372 16.7084C8.17539 16.7334 8.37539 16.7584 8.57539 16.7751C9.05039 16.8167 9.53372 16.8417 10.0171 16.8417C10.4921 16.8417 10.9671 16.8167 11.4337 16.7751C11.6087 16.7584 11.7837 16.7501 11.9504 16.7251C12.0837 16.7084 12.2171 16.6917 12.3587 16.6751Z",
		fill: "#407BFF"
	})]
});
export default SvgBellFill;
